import styled from 'styled-components';
import DefaultContentLoader from 'react-content-loader';
import { ComponentProps } from './types';

export const Container = styled.div``;

export const ContentLoader = styled(DefaultContentLoader)<ComponentProps>`
  width: 100%;
  opacity: ${(props) => props.$opacity};
`;
